import { useDispatch } from "react-redux";

import { CaseDocumentAdmin } from "pwapi";

import { deleteAdminCaseDocument } from "shared/actions/admin/adminDocumentsActions";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import PopUpDialog from "../PopUpDialog";

export const DocumentWarningDialog = ({
  document,
  onClose,
  closePanel,
}: {
  document: CaseDocumentAdmin;
  onClose: Function;
  closePanel: Function;
}) => {
  const dispatch = useDispatch();

  const onCompleteDeletion = () => {
    onClose();
    closePanel();
  };

  const onDeleteDocument = () => {
    document.id &&
      dispatch(
        deleteAdminCaseDocument({
          id: document.id,
          onClose: onCompleteDeletion,
        })
      );
  };

  return (
    <PopUpDialog
      onClose={() => onClose()}
      title={document?.name && `Delete ${document.name}`}
      type="warning"
    >
      <div className="CaseWarningDialog">
        <span>
          Are you sure you want to delete {document.name}?
          <br />
          This action cannot be undone.
        </span>
        <div className="actions__container">
          <PathologyWatchButton onClick={() => onClose()}>
            Cancel
          </PathologyWatchButton>
          <PathologyWatchButton
            type="submit"
            color="red"
            onClick={() => {
              onDeleteDocument();
            }}
          >
            Delete
          </PathologyWatchButton>
        </div>
      </div>
    </PopUpDialog>
  );
};

export default DocumentWarningDialog;
